import { FlexContainer, Icon, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import * as Styled from './styles';

const BenefitsList = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);

  return (
    <FlexContainer mt="fds_size_24">
      <Styled.ListContainer>
        {[...Array(4).keys()].map(item => (
          <Styled.ListItem align="center" key={item}>
            <Icon icon="IconArrowRightM" color="default" />
            <Styled.ListItemText>
              <Text ml="fds_size_08" type="paragraphs" color="dark" size="S_M_S">
                {t(`Previous.years.result.items.${item}`)}
              </Text>
            </Styled.ListItemText>
          </Styled.ListItem>
        ))}
      </Styled.ListContainer>
    </FlexContainer>
  );
};

export default BenefitsList;
